import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpandLess = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2377_34869",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 16,
		height: 16,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2377_34869)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.93297 10.0255L4.23047 9.32288L7.99964 5.55371L11.7688 9.32288L11.0663 10.0255L7.99964 6.95888L4.93297 10.0255Z",
			fill: "#118AB2"
		})
	})]
});
export default SvgExpandLess;
